import actions from "./actions";

const stateDefault = {
    workspace: [],
    details: {},
    workspacesToAllocate: null,
    invitedToWorkspace: null
};

export default function usersReducer(state = stateDefault, action: { type: string; payload: any; }): any {
    switch (action.type) {
        case actions.SET_DATA:
            return {...state, workspace: action.payload};
        case actions.SET_WORKSPACE_DETAILS:
            return {...state, details: action.payload};
        case actions.SET_WORKSPACES_TO_ALLOCATE:
            return {...state, workspacesToAllocate: action.payload};
        case actions.SET_INVITED_TO_WORKSPACE:
            return {...state, invitedToWorkspace: action.payload};
        default:
            return state
    }
}
